import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

interface DemographicData {
    type?: string;
    race?: string;
    count: number;
    percentage: number;
}

// Dados simulados para cada categoria demográfica
const genderData: DemographicData[] = [
    { type: 'Masculino', count: 126, percentage: 59.2 },
    { type: 'Feminino', count: 87, percentage: 40.8 },
];

const sexualityData: DemographicData[] = [
    { type: 'Heterossexual', count: 189, percentage: 88.7 },
    { type: 'Homossexual', count: 15, percentage: 7.0 },
    { type: 'Bissexual', count: 9, percentage: 4.3 },
];

const raceData: DemographicData[] = [
    { race: 'Branco', count: 98, percentage: 46.0 },
    { race: 'Pardo', count: 67, percentage: 31.5 },
    { race: 'Negro', count: 32, percentage: 15.0 },
    { race: 'Indígena', count: 8, percentage: 3.8 },
    { race: 'Asiático', count: 8, percentage: 3.8 },
];

const COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6'];

const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
        const data = payload[0].payload;
        return (
            <div className="bg-white p-2 border border-gray-200 rounded shadow-lg">
                <p className="font-medium text-gray-900 text-sm">{data.type || data.range || data.race}</p>
                <p className="text-xs text-gray-600">
                    {data.count} colaboradores
                    {data.percentage && ` (${data.percentage}%)`}
                </p>
            </div>
        );
    }
    return null;
};

const MiniPieChart = ({ data, title }: { data: DemographicData[], title: string }) => (
    <div className="text-center">
        <h4 className="text-sm font-medium text-gray-900 mb-3">{title}</h4>
        <div className="h-32">
            <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                    <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        outerRadius={45}
                        fill="#8884d8"
                        dataKey="count"
                        stroke="#ffffff"
                        strokeWidth={2}
                    >
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                    </Pie>
                    <Tooltip content={<CustomTooltip />} />
                </PieChart>
            </ResponsiveContainer>
        </div>
        <div className="mt-3 space-y-2">
            {data.map((item, index) => (
                <div key={item.type || item.race} className="flex items-center justify-between text-xs">
                    <div className="flex items-center">
                        <div
                            className="w-3 h-3 rounded-full mr-2"
                            style={{ backgroundColor: COLORS[index] }}
                        />
                        <span className="text-gray-700">{item.type || item.race}</span>
                    </div>
                    <span className="font-medium text-gray-900">
                        {item.count} ({item.percentage}%)
                    </span>
                </div>
            ))}
        </div>
    </div>
);



export default function DemographicInsights() {
    return (
        <div className="bg-white rounded-lg shadow p-6 col-span-2">
            {/* Header */}
            <div className="mb-6">
                <h3 className="text-base font-semibold text-gray-900 mb-1">
                    Dados Demográficos
                </h3>
                <p className="text-xs text-gray-600">
                    Perfil demográfico dos colaboradores
                </p>
            </div>

            {/* Demographics Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <MiniPieChart
                    data={genderData}
                    title="Sexo"
                />

                <MiniPieChart
                    data={sexualityData}
                    title="Orientação Sexual"
                />

                <MiniPieChart
                    data={raceData}
                    title="Raça/Etnia"
                />
            </div>
        </div>
    );
} 